import videojs from 'video.js';
import { throttle } from '../../helpers/throttle-debounce';

const browser = videojs.browser;

class MatchTV extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player);
		this.onDisposeActions = [];
		this.player.ready(() => {
			this.addPointToPlayProgressBar();

			// Ipad и iphone работают на разных OS
			if (browser.IS_IPHONE || browser.IS_IPAD) {
				this.hideVolumeControlForIos();
			}
		});
		this.on('dispose', () => {
			this.onDisposeActions.forEach((fn) => fn());
		});
	}

	hideVolumeControlForIos() {
		const volumePanel = this.player.getDescendant(['controlBar', 'volumePanel']);
		const volumeControl = this.player.getDescendant(['controlBar', 'volumePanel', 'volumeControl']);
		if (!volumeControl || !volumePanel) return;

		volumePanel.addClass('vjs-mute-toggle-only');
		volumeControl.hide();
	}

	addPointToPlayProgressBar() {
		// Использование .vjs-time-tooltip не подходит,
		// т.к. VideoJS не добавляет этот элемент на мобильных устройствах.
		// См. https://github.com/videojs/video.js/blob/v7.21.4/src/js/control-bar/progress-control/play-progress-bar.js#L82
		const seekBar = this.player.getDescendant(['controlBar', 'ProgressControl', 'SeekBar']);
		const playProgressBar = this.player.getDescendant(['controlBar', 'ProgressControl', 'SeekBar', 'PlayProgressBar']);
		if (!playProgressBar) return;
		const pointComponent = playProgressBar.addChild('Component', {
			className: 'vjs-play-progress-point'
		});
		const pointEl = pointComponent.el();
		function onStartMove(moveEventName, endEventName) {
			playProgressBar.addClass('vjs-play-progress_mousemove');
			const handleMove = throttle(100, () => {
				pointEl.parentElement.style.width = `${seekBar.getProgress() * 100}%`;
			});
			const handleEnd = () => {
				pointEl.parentElement.style.width = `${seekBar.getProgress() * 100}%`;
				playProgressBar.removeClass('vjs-play-progress_mousemove');
				document.removeEventListener(moveEventName, handleMove);
				document.removeEventListener(endEventName, handleEnd);
			}
			document.addEventListener(moveEventName, handleMove);
			document.addEventListener(endEventName, handleEnd);
		}
		const handleMouseMove = onStartMove.bind(null, 'mousemove', 'mouseup');
		pointEl.addEventListener('mousedown', handleMouseMove);
		const handleTouchMove = onStartMove.bind(null, 'touchmove', 'touchend');
		pointEl.addEventListener('touchstart', handleTouchMove);
		const handleMouseEnter = () => {
			this.player.addClass('vjs-play-progress-point-hover');
		};
		pointEl.addEventListener('mouseenter', handleMouseEnter);
		pointEl.addEventListener('pointerenter', handleMouseEnter);

		const handleMouseLeave = () => {
			this.player.removeClass('vjs-play-progress-point-hover');
		};
		pointEl.addEventListener('mouseleave', handleMouseLeave);
		pointEl.addEventListener('pointerleave', handleMouseLeave);

		this.onDisposeActions.push(() => {
			pointEl.removeEventListener('mouseenter', handleMouseEnter);
			pointEl.removeEventListener('pointerenter', handleMouseEnter);
			pointEl.removeEventListener('mouseleave', handleMouseLeave);
			pointEl.removeEventListener('pointerleave', handleMouseLeave);
			pointEl.removeEventListener('mousedown', handleMouseMove);
			pointEl.removeEventListener('touchstart', handleTouchMove);
		});
	}
}

videojs.registerPlugin('matchTV', MatchTV);
